import { render } from "./GroupTimetablePage.vue?vue&type=template&id=1ad9afc3"
import script from "./GroupTimetablePage.vue?vue&type=script&lang=js"
export * from "./GroupTimetablePage.vue?vue&type=script&lang=js"

import "./GroupTimetablePage.vue?vue&type=style&index=0&id=1ad9afc3&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__